import { Icon } from '@src/components/Icon';
import type { ComboboxMultipleProperties } from '../ComboboxMultiple';

type ComboboxLeadingIconProperties<T> = Pick<
  ComboboxMultipleProperties<T>,
  'leadingIcon'
>;

export function ComboboxLeadingIcon<T>({
  leadingIcon,
}: ComboboxLeadingIconProperties<T>) {
  if (!leadingIcon) {
    return null;
  }

  return (
    <Icon
      type={leadingIcon}
      className="absolute left-4 top-1/2 transform -translate-y-1/2 text-[#9198A3] h-6 w-6"
    />
  );
}
